import { useCallback } from 'react';

import { useIsTouchDevice } from '@/hooks/use-mobile';
import { focusInPlace } from '@/lib/utils/dom';

const COMPOSER_INPUT_ATTRIBUTE = 'data-composer-input';

/** Marks the thread's composer input, for callers outside the composer that move focus to it. */
export const COMPOSER_INPUT_PROPS = { [COMPOSER_INPUT_ATTRIBUTE]: '' };

export function findComposerInput(): HTMLElement | null {
  return document.querySelector<HTMLElement>(`[${COMPOSER_INPUT_ATTRIBUTE}]`);
}

/**
 * Focuses the composer input, except on a touch device, where that opens the on-screen keyboard
 * over the chat unasked. There `onTouch`, when given, takes focus instead.
 */
export function useFocusComposer() {
  const isTouchDevice = useIsTouchDevice();
  return useCallback(
    function focusComposer({
      input,
      onTouch,
    }: {
      input: HTMLElement | null | undefined;
      onTouch?: HTMLElement | null;
    }) {
      if (isTouchDevice) {
        focusInPlace(onTouch);
        return;
      }
      input?.focus();
    },
    [isTouchDevice],
  );
}
